import { api } from './api';

export interface PipelineByStageRow {
  stage_key: string;
  stage_label: string;
  stage_position: number;
  count: number;
  total_amount_cents: number;
}

export interface PipelineByOwnerRow {
  owner_user_id: string | null;
  owner_name: string | null;
  open_count: number;
  total_amount_cents: number;
  won_count: number;
  won_amount_cents: number;
}

export interface SignalConversionRow {
  kind: string;
  signal_count: number;
  contacts_acted_on: number;
  sequences_started: number;
  deals_created: number;
}

export interface SequencePerformanceRow {
  sequence_id: string;
  sequence_name: string;
  enrolled: number;
  replied: number;
  bounced: number;
  finished: number;
}

export interface SignalRoiRow {
  kind: string;
  signal_count: number;
  pipeline_amount_cents: number;
  deal_count: number;
}

export const reportsApi = {
  pipelineByStage: async (workspaceId: string) => {
    const r = await api.get<{ items: PipelineByStageRow[] }>(
      '/api/reports/pipeline-by-stage',
      { params: { workspaceId } },
    );
    return r.data;
  },
  pipelineByOwner: async (workspaceId: string) => {
    const r = await api.get<{ items: PipelineByOwnerRow[] }>(
      '/api/reports/pipeline-by-owner',
      { params: { workspaceId } },
    );
    return r.data;
  },
  signalConversion: async (workspaceId: string, sinceDays = 30) => {
    const r = await api.get<{ items: SignalConversionRow[] }>(
      '/api/reports/signal-conversion',
      { params: { workspaceId, sinceDays } },
    );
    return r.data;
  },
  sequencePerformance: async (workspaceId: string) => {
    const r = await api.get<{ items: SequencePerformanceRow[] }>(
      '/api/reports/sequence-performance',
      { params: { workspaceId } },
    );
    return r.data;
  },
  signalRoi: async (workspaceId: string, sinceDays = 90) => {
    const r = await api.get<{ items: SignalRoiRow[] }>(
      '/api/reports/signal-roi',
      { params: { workspaceId, sinceDays } },
    );
    return r.data;
  },
};
